/**
 * SKŁADNIA createAsyncThunk:
 * https://redux-toolkit.js.org/api/createAsyncThunk
 */


import { createAsyncThunk } from '@reduxjs/toolkit'
import { SLICE_KEYS } from '../../SliceKeys'
import { SmsCodeService } from 'service/SmsCodeService/SmsCodeService'
import { submitSmsCodeAgain } from '../ContractSignSlice'

export const submitSmsCodeAgainThunkAction = createAsyncThunk(
   `${SLICE_KEYS.CONTRACT_SIGN_SLICE}/submitSmsCodeAgainThunkAction`,
   async(_, thunkApi) => {
      const smsCodeService = new SmsCodeService()

      thunkApi.dispatch(submitSmsCodeAgain())
      const submitAgainSmsCodeResponse = await smsCodeService.submitAgainSmsCode()

      return submitAgainSmsCodeResponse
   }
)